import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
const defaultTextBBox = {
    width: 0,
    height: 0,
    x: 0,
    y: 0,
};
export function SVGText(props) {
    const textRef = useRef(null);
    const [boxSize, setBoxSize] = useState(defaultTextBBox);
    const { rectProps = {}, padding = 0, borderRadius = 0, children, ...otherProps } = props;
    const { ...otherRectProps } = rectProps;
    useLayoutEffect(() => {
        const boundary = textRef?.current?.getBBox();
        if (boundary) {
            setBoxSize(boundary);
        }
    }, []);
    const { width: textWidth, height: textHeight, x, y } = boxSize;
    const width = textWidth + padding * 2;
    const height = textHeight + padding * 2;
    return (_jsxs("g", { children: [_jsx("rect", { width: width, height: height, x: x - padding, y: y - padding, fill: "transparent", ...(borderRadius && { rx: borderRadius, ry: borderRadius }), ...otherRectProps }), _jsx("text", { ref: textRef, fill: "black", textAnchor: "middle", ...otherProps, children: children })] }));
}
